
import * as Yup from "yup";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import DropingPointModel from "../../models/party/dropingpoint-model";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TextArea } from "@progress/kendo-react-inputs";
import { TimePicker, TimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { useEffect, useState } from "react";
import { useGetCategories } from "../../apiclient/master/useGetCategoryApi";
import { useGetAgent } from "../../apiclient/party/useGetAgentApi";
import { SelectField } from "../../core/select-field.component";
import { useGetWards } from "../../apiclient/master/useGetWardApi";
import { useGetZones } from "../../apiclient/master/useGetZoneApi";
import { useGetConstituency } from "../../apiclient/master/useGetConstituencyApi";
import { useGetArea,  useGetDroppingPoints } from "../../apiclient/party/useGetDropingPointApi";
import { useGetRoute } from "../../apiclient/master/useGetRouteApi";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { useGetStates } from "../../apiclient/master/useGetStateApi";
import { useGetTaluks } from "../../apiclient/master/useGetTalukApi";
import { useGetUnions } from "../../apiclient/master/useGetUnionsApi";
import GeoLocated, { useGetLocationCoords } from "../../components/GeoLocationTextForm";
import useGeolocated from "../../components/GeoLocationTextForm";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { FormikPage } from "../../core/formik-page-forms";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";



interface CustomerEditProps {
  data: DropingPointModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}


const CustomerEntry: React.FC<CustomerEditProps> = ({ ...props }) => {
  let { data, onClose, isViewMode } = props;
  const title = data?.droppingpointId > 0 ? "Edit Customer" : "Add Customer";
  const [selectedTab, setSelectedTab] = useState<number>(0);


  let initialValue: DropingPointModel = {
    droppingpointId: data?.droppingpointId ? data.droppingpointId : 0,
    categoryId: data?.categoryId,
    code: data?.code ,
    name: data?.name,
    address: data?.address,
    pincode: data?.pincode,
    landmark: data?.landmark,
    agentId: data?.agentId ? data.agentId : 0,
    isActive: data?.droppingpointId > 0 ? data.isActive : true,
    morningRouteId: data?.morningRouteId ? data.morningRouteId : 0,
    morningRouteOrder: data?.morningRouteOrder ? data.morningRouteOrder : 0,
    eveningRouteId: data?.eveningRouteId ? data.eveningRouteId : 0,
    eveningRouteOrder: data?.eveningRouteOrder ? data.eveningRouteOrder : 0,
    areaId: data?.areaId ? data.areaId : 0,
    latitude: data?.latitude,
    longitude: data?.longitude,
    constituencyId: data?.constituencyId,
    wardId: data?.wardId,
    zoneId: data?.zoneId,
    districtId:data?.districtId,
    stateId:data?.stateId ,
    talukId:data?.talukId,
    unionId:data?.unionId,
    minimumOrderQuantity: data?.minimumOrderQuantity,
    maximumOrderQuantity: data?.maximumOrderQuantity,
    creditLimit: data?.creditLimit,
    accountCode: data?.accountCode,
    isOtherState:data?.isOtherState || true,
    gstIn:data?.gstIn,
    type:data?.type? data.type:2,




  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Required")
      .test("check-duplicate-name", "customer name already exists", (value) => {
        // Ensure the value is compared in a case-insensitive manner
        return (
          value &&
          !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
          (data?.name && value === data.name) // Allow current name during update
        );
      }),
    // code: Yup.string()
    //   .required(" Code is required")
    //   .test("check-duplicate-code", " Code already exists", (value) => {
    //     return !existingcode.includes(value) ||
    //       (data?.code && value === data.code) // 
    //   }),
    gstIn: Yup.string().required(" GstIn is required"),
    categoryId: Yup.number()
      .required("Category is required")
      .test("categoryId-not-zero", "Category must be selected", (value) => value !== 0),
  });


  const [existingName, setExistingName] = useState<string[]>([]);
  const { data: fetchedDroppingPoint } = useGetDroppingPoints();


  const [existingcode, setExistingCode] = useState<string[]>([]);
  const { data: fetchedDropingPoint } = useGetDroppingPoints();

  const [agentData, setAgentData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedAgent } = useGetAgent();

  const [categoryData, setCategoryData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedcategory } = useGetCategories();

  const [routeData, setRouteData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedRoute } = useGetRoute();

  const [areaData, setAreaData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedArea } = useGetArea();

  const [constituencyData, setConstituencyData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedConstituency } = useGetConstituency();

  const [wardData, setWardData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedWard } = useGetWards();

  const [zoneData, setZoneData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedZone } = useGetZones();

  const [districtData, setDistrictData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedDistrict } = useGetDistrict();

  const [stateData, setStateData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedState } = useGetStates();

  const [talukData, setTalukData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedTaluk } = useGetTaluks();

  const [unionData, setUnionData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedUnion } = useGetUnions();

  const [lat, setLat] = useState<string>("");
  const [Long, setLong] = useState<string>("");

  const getLocation = useGetLocationCoords();



  useEffect(() => {

    if (fetchedDropingPoint) {
      // Extract employee codes and PAN numbers from the fetched data
      setExistingCode(fetchedDropingPoint.map((dro: any) => dro.code));
    }
    if (fetchedDroppingPoint) {

      setExistingName(fetchedDroppingPoint.map((Dro: any) => Dro.name));
    }


    if (fetchedAgent) {
      const mappedagent = fetchedAgent.map((agent: any) => ({
        value: agent.agentId,
        label: agent.agentCode + "-" + agent.firstName
      }));
      setAgentData(mappedagent);
    }
    if (fetchedRoute) {
      const mappedmorningroute = fetchedRoute.map((morningroute: any) => ({
        value: morningroute.routeId,
        label: morningroute.name,
      }));
      setRouteData(mappedmorningroute);
    }
    if (fetchedRoute) {
      const mappedeveningroute = fetchedRoute.map((eveningroute: any) => ({
        value: eveningroute.routeId,
        label: eveningroute.name,
      }));
      setRouteData(mappedeveningroute);
    }

    if (fetchedcategory) {
      const mappedcategory = fetchedcategory.map((category: any) => ({
        value: category.categoryId,
        label: category.name,
      }));
      setCategoryData(mappedcategory);
    }

    if (fetchedArea) {
      const mappedarea = fetchedArea.map((area: any) => ({
        value: area.areaId,
        label: area.name,
      }));
      setAreaData(mappedarea);
    }
    if (fetchedConstituency) {
      const mappedconstituency = fetchedConstituency.map((constituency: any) => ({
        value: constituency.constituencyId,
        label: constituency.name,
      }));
      setConstituencyData(mappedconstituency);
    }
    if (fetchedWard) {
      const mappedward = fetchedWard.map((ward: any) => ({
        value: ward.wardId,
        label: ward.name,
      }));
      setWardData(mappedward);
    }
    if (fetchedZone) {
      const mappedzone = fetchedZone.map((zone: any) => ({
        value: zone.zoneId,
        label: zone.name,
      }));
      setZoneData(mappedzone);
    }
    if (fetchedDistrict) {
      const mappeddistrict = fetchedDistrict.map((district: any) => ({
        value: district.districtId,
        label: district.name,
      }));
      setDistrictData(mappeddistrict);
    }
    if (fetchedState) {
      const mappedstate = fetchedState.map((state: any) => ({
        value: state.stateId,
        label: state.name,
      }));
      setStateData(mappedstate);
    }
    if (fetchedTaluk) {
      const mappedtaluk = fetchedTaluk.map((taluk: any) => ({
        value: taluk.talukId,
        label: taluk.name,
      }));
      setTalukData(mappedtaluk);
    }
    if (fetchedUnion) {
      const mappedunion = fetchedUnion.map((union: any) => ({
        value: union.unionId,
        label: union.name,
      }));
      setUnionData(mappedunion);
    }

    return () => {
      setLat("");
      setLong("");
    }



  }, [fetchedZone, fetchedDroppingPoint, fetchedWard, fetchedConstituency, fetchedArea, fetchedAgent, fetchedRoute, fetchedDistrict, fetchedState, fetchedTaluk, fetchedUnion, fetchedDropingPoint]);

  const [codeFromCategory, setCodeFromCategory] = useState("");

  const fetchCategoryCode = async (categoryId: number) => {
    try {
      const response = await getDataWithToken<any>(
        `${getEndPoint(API_END_POINT.PARTY)}/api/Droppingpoint/GetDroppingpointcode/${categoryId}`
      );
      const generatedCode = response.data.result;
      setCodeFromCategory(generatedCode);

    } catch (err) {
      console.error("Error fetching code from category:", err);
    }
  };

  useEffect(() => {
    if (!data?.droppingpointId) {
      setCodeFromCategory("");
    } else {
      setCodeFromCategory(data.code || "");
    }
  }, [data]);


  return (

    <FormikModelDialog
      width="80%"
      title={title}
      initialData={initialValue}
      validationSchema={validationSchema}
      show={!!data}
      onClose={onClose}
      endpoint={API_END_POINT.PARTY}
      postRoute="DroppingPoint/SaveDropingPoint"
      showAddAnother={true}
      isUpDateEntityDetails={data?.droppingpointId > 0 ? true : false}
      isViewOnly={isViewMode}
    >

      <div className="bg-white-head tabwhitespace" style={{ width: "100%" }}>
        <div className="rounded-tab-strip">
          <TabStrip
            selected={selectedTab}
            onSelect={(e) => {
              setSelectedTab(e.selected);
            }}
            className="mx-2 mt-3 mb-3 bg-light"
            style={{ minHeight: "35vh", minWidth: "40vw" }}
          >
            <TabStripTab contentClassName="structureTab" title="Profile" >
              <div className="group-container" style={{ width: '100%', padding: '15px', marginBottom: '15px' }}>
                <div className="row d-flex flex-wrap">
                  {/* <div className="col-md-3"> <SelectField label="Category" name="categoryId" options={categoryData} unSelectValue={0} /></div> */}
                  <div className="col-md-3"> <SelectField
                    label="Category"
                    name="categoryId"
                    options={categoryData}
                    unSelectValue={0}
                    notifyChange={(selectedValue: number) => {
                      if (selectedValue && selectedValue !== 0) {
                        fetchCategoryCode(selectedValue);
                      }
                    }}
                  /></div>

                  <div className="col-md-3"><label style={{ marginBottom: "5px" }}>Code</label> <input className="form-control mb-3" maxLength={50} name="code" value={codeFromCategory} disabled /></div>
                  {/* <div className="col-md-3"> <InputField maxLength={50} label="Code" name="code" /></div> */}
                  <div className="col-md-3"> <InputField maxLength={50} label="Name" name="name" /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Address" name="address" /></div>
                  <div className="col-md-3"> <InputField maxLength={6} label="Pincode" name="pincode" /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="LandMark" name="landmark" /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Latitude" name="latitude" onClick={() => { const res = getLocation(); setLat(res.loc.latitude); }} /> </div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Longitude" name="longitude" onClick={() => { const res = getLocation(); setLong(res.loc.longitude); }} /></div>
                  <div className="col-md-3"> <CheckboxField label="Active?" name="isActive" checkstyle={CheckBoxStyle.Normal} /></div>
                  <div className="col-md-3"> <CheckboxField label="OtherState?" name="isOtherState" checkstyle={CheckBoxStyle.Normal} /></div>

                </div>
              </div>
            </TabStripTab>

            <TabStripTab contentClassName="structureTab" title="Routes & Finance">
              <div className="group-container" style={{ width: '100%', padding: '15px', marginBottom: '15px' }}>
                <div className="row d-flex flex-wrap">
                  <div className="col-md-3"> <SelectField label="Agent" name="agentId" options={agentData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="Zone" name="zoneId" options={zoneData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="Morning Route" name="morningRouteId" options={routeData} /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Morning Route Order" name="morningRouteOrder" /></div>

                  <div className="col-md-3"> <SelectField label="Evening Route" name="eveningRouteId" options={routeData} /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Evening Route Order" name="eveningRouteOrder" /></div>

                  <div className="col-md-3"> <InputField maxLength={50} label="Min Order Quantity" name="minimumOrderQuantity" /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Max Order Quantity" name="maximumOrderQuantity" /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Credit Limit" name="creditLimit" /></div>
                  <div className="col-md-3"> <InputField maxLength={50} label="Account Code" name="accountCode" /></div>
                  <div className="col-md-3"> <InputField maxLength={15} label="Gst In" name="gstIn" /></div>

                </div>
              </div>
            </TabStripTab>

            <TabStripTab contentClassName="structureTab" title="Region Mapping">
              <div className="group-container" style={{ width: '100%', padding: '15px', marginBottom: '15px' }}>
                <div className="row d-flex flex-wrap">
                  <div className="col-md-3"> <SelectField label="Union" name="unionId" options={unionData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="District" name="districtId" options={districtData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="State" name="stateId" options={stateData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="Taluk" name="talukId" options={talukData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="Constituency" name="constituencyId" options={constituencyData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="Ward" name="wardId" options={wardData} unSelectValue={0} /></div>
                  <div className="col-md-3"> <SelectField label="Area" name="areaId" options={areaData} unSelectValue={0} /></div>
                </div>
              </div>
            </TabStripTab>
          </TabStrip>
        </div>
      </div>

    </FormikModelDialog>

  );
};

export default CustomerEntry;
